module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.11e81b30.jpg";